import { Component, Input, OnInit } from '@angular/core';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { DataService, DateRange, GoodReport } from '@core/services/data.service';
import { PartnersService } from '@core/services/partners.service';
import { TagsService } from '@core/services/tags.service';
import { SynchronizationService } from '@core/services/synchronization.service';

@Component({
  templateUrl: './exports-viewer.component.html',
  styleUrls: ['./exports-viewer.component.scss']
})
export class ExportsViewerComponent implements OnInit {

  @Input()
  public range: { name: string, range: DateRange };

  @Input()
  public reports: GoodReport[];

  @Input()
  public SKU: string;

  @Input()
  public color: string;

  public details: Filterable<GoodReport> = new Filterable<GoodReport>({
    extractor: i => [this.name(i.Path[0]), i.Path[0]],
    grouper: i => [{ name: 'Khách hàng', option: this.name(i.Path[0]) }]
  });

  constructor(private partners: PartnersService, private tags: TagsService, private sync: SynchronizationService) { }

  ngOnInit(): void {

    let lu: { [key: string]: GoodReport } = {};

    this.reports.forEach(i => {
      if (!lu[i.Path[0]]) {
        lu[i.Path[0]] = { ...i };
      }
      else {
        lu[i.Path[0]].Exports.LengthCount += i.Exports.LengthCount;
        lu[i.Path[0]].Exports.LengthQuantity += i.Exports.LengthQuantity;
        lu[i.Path[0]].Exports.LengthQuoteQuantity += i.Exports.LengthQuoteQuantity;
        lu[i.Path[0]].Exports.WeightCount += i.Exports.WeightCount;
        lu[i.Path[0]].Exports.WeightQuantity += i.Exports.WeightQuantity;
        lu[i.Path[0]].Exports.WeightQuoteQuantity += i.Exports.WeightQuoteQuantity;
        lu[i.Path[0]].Exports.QuoteValue += i.Exports.QuoteValue;
        lu[i.Path[0]].Exports.QuoteWorth += i.Exports.QuoteWorth;
        lu[i.Path[0]].Exports.BaseWorth += i.Exports.BaseWorth;

      }
    })

    let source: GoodReport[] = [];

    for (let o in lu) source.push(lu[o]);

    this.sync.when(PartnersService, TagsService).commit(() => {
      this.details.source = source.filter(i => i.Exports.LengthCount + i.Exports.WeightCount > 0);
    });       
  }

  public name(tag: string): string {
    let t = this.tags.get(tag);
    if (!t) return '';

    let p = this.partners.get(t.PartnerID);
    return p ? p.Name : '';
  }

  public extractor(field: string): SortableExtractor<GoodReport> {
    return {
      extract: i => {
        switch (field) {
          case 'Tag': return i.Path[0];
          case 'ReducedQuantity': return i.Exports.LengthQuantity - i.Exports.LengthQuoteQuantity + i.Exports.WeightQuantity - i.Exports.WeightQuoteQuantity;
          case 'QuoteQuantity': return i.Exports.LengthQuoteQuantity + i.Exports.WeightQuoteQuantity;
          case 'BasePrice': return i.Exports.BaseWorth / (i.Exports.LengthQuoteQuantity + i.Exports.WeightQuoteQuantity);
          case 'QuotePrice': return i.Exports.QuoteValue / (i.Exports.LengthQuoteQuantity + i.Exports.WeightQuoteQuantity);
          case 'Base': return i.Exports.BaseWorth;
          case 'Quote': return i.Exports.QuoteWorth;
          case 'Value': return i.Exports.QuoteValue;
          default: return i.Exports[field];

        }
      }
    }
  }

  public sum(field: string): number {
    return this.details.matches.sum(i => {
      switch (field) {
        case 'ReducedLength': return i.Exports.LengthQuantity - i.Exports.LengthQuoteQuantity;
        case 'ReducedWeight': return i.Exports.WeightQuantity - i.Exports.WeightQuoteQuantity;
        case 'Base': return i.Exports.BaseWorth;
        case 'Quote': return i.Exports.QuoteWorth;
        case 'Value': return i.Exports.QuoteValue;
        default: return i.Exports[field];
      }
    });
  }
}
